import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import {
  FinishAppCreationRequest,
  TogglePayingPublicationAddon,
} from '@app/features/app-content/states/app-configuration.actions';
import { Store } from '@ngxs/store';
import { PublicationAddonDialogComponent } from '../../plan/publication-addon-dialog/publication-addon-dialog.component';

@Injectable({ providedIn: 'root' })
export class FinishCreationFlowService {
  constructor(
    private readonly store: Store,
    private readonly dialog: MatDialog,
  ) {}

  // runs the finish creation flow. opens the addon dialog when needed, then dispatches finish request
  run(): void {
    const planId = this.store.selectSnapshot(AppConfigurationState.currentAppIdPlan);
    const isPaidApp = this.store.selectSnapshot(AppConfigurationState.isPaidApp);

    // if premium plan or already paid, just finish
    if (planId === 6 || isPaidApp) {
      this.store.dispatch(new FinishAppCreationRequest());

      return;
    }

    // otherwise ask for addon confirmation
    // prevent scrolling when the dialog is opened
    document.body.classList.add('disable-scroll');
    const dialogRef = this.dialog.open(PublicationAddonDialogComponent, {});

    dialogRef.afterClosed().subscribe(result => {
      // always restore scrolling when dialog closes
      document.body.classList.remove('disable-scroll');

      if (result === undefined) {
        return;
      }

      this.store.dispatch(new TogglePayingPublicationAddon(!!result));
      this.store.dispatch(new FinishAppCreationRequest());
    });
  }
}
